import React, { Component } from "react";
import { UserConsumer } from "../../UserContext";
import Header from "../timesheetModule/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import "./dashboard.scss";
import Highcharts from "highcharts";
import PieChart from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown.js";
import { Row, Col, Spinner, Table, Label } from "reactstrap";
import { Image, Modal } from "react-bootstrap";
import homeIcon from "../../images/icons/homeIcon.png";
import officeIcon from "../../images/icons/officeIcon.png";
import {
	SpOptionsPie,
	title,
	departmentIds,
	TeamWorkStationCountChart,
	SpOptionsPieWFO,
	SpOptionsPieWFH,
	SupervisorTimesheetPerformance,
	TimesheetPerformanceLineChart,
	SpOptionsPieCWFO,
} from "./DashboardVariables";
import axios from "axios";
import { Dashboard_APIs } from "./DashboardAPIs";
import { Link } from "react-router-dom";
import ProjectTeam from "./ProjectTeam";
import { connect } from "react-redux";
import {
	UpdateNavBarItem,
	UpdateNavBarTab,
} from "../../components/navbarRedux/action";
import { Loader } from "../ticketModule/variables/ListingVariables";
import SpWorkStationModal from "./SpWorkStationModal";
import CustomReactSelect from "../../components/CustomReactSelect";
import moment from "moment";
import { Routes } from "../../configurations/config";
let token,
	empJoinedOn = null;
drilldown(Highcharts);

let department,
	empDesignation,
	employeeId = "";
const monthsList = [
	{ value: 0, label: "All" },
	{ value: 1, label: "January" },
	{ value: 2, label: "February" },
	{ value: 3, label: "March" },
	{ value: 4, label: "April" },
	{ value: 5, label: "May" },
	{ value: 6, label: "June" },
	{ value: 7, label: "July" },
	{ value: 8, label: "August" },
	{ value: 9, label: "September" },
	{ value: 10, label: "October" },
	{ value: 11, label: "November" },
	{ value: 12, label: "December" },
];
const groupByList = [
	{ value: 1, label: "Week" },
	{ value: 2, label: "Month" },
];
class SpDashboard extends Component {
	constructor(props) {
		super(props);
		this.TimesheetPerLinechart = React.createRef();
		this.timehseetPiechart = React.createRef();
		this.state = {
			pendingTickets: 0,
			pending: 0,
			submitted: 0,
			approved: 0,
			rejected: 0,
			projectTeam: [],
			empLateComing: [],
			empLeaves: [],
			empWorkStationPercentage: [],
			empCheckinCheckout: [],
			leavesRequests: 0,
			offSiteWorkrequests: 0,
			showModal: false,
			timesheetPerformanceChart: {
				...SupervisorTimesheetPerformance,
			},
			miscPie: {
				...SpOptionsPie,
			},
			orgPie: {
				...SpOptionsPie,
			},
			preSalesPie: {
				...SpOptionsPie,
			},
			projectsPie: {
				...SpOptionsPie,
			},
			TeamWorkStationChart: {
				...TeamWorkStationCountChart,
			},
			TeamWorkStationChartWFO: {
				...SpOptionsPieWFO,
			},
			TeamWorkStationChartWFH: {
				...SpOptionsPieWFH,
			},
			TeamWorkStationChartCWFO: {
				...SpOptionsPieCWFO,
			},
			workFromHome: [],
			workFromOffice: [],
			WFxCategoris: [],
			marker: {
				symbol: "circle",
				fillColor: "white",
				lineColor: null,
				lineWidth: 2,
			},
			currProj: "",
			projData: [],
			orgProjData: [],
			presalesProjData: [],
			timesheetStatus: "",
			timesheetStatusLoading: true,
			ticketsLoading: false,
			teamLeavesandOffSiteReqLoading: true,
			TeamWorkStationData: [],
			showSpWorkStationModal: false,
			SpWorkStationModalEmp: null,
			ALLEmployeeWSData: [],
			showALLEmployeeWSData: false,
			timesheetPerformanceData: [],
			yearList: [],
			selectedYear: null,
			selectedMonth: monthsList[0],
			employeesList: [],
			selectedEmployee: null,
			timesheetPerformancePieChartLoading: true,
			timesheetPerformanceLineChartLoading: true,
			TimesheetPerformanceLineChart: {
				...TimesheetPerformanceLineChart,
			},
			performanceLineChartData: [],
			TimesheetPerformanceMEE: [],
			TimesheetPerformanceMEPlus: [],
			TimesheetPerformanceME: [],
			TimesheetPerformanceMEMinus: [],
			TimesheetPerformanceFME: [],
			TimesheetPerformanceCategories: [],
			TimesheetPerformanceSelectedGrouBy: groupByList[0],
		};
	}
	componentDidMount() {
		let headers = {
				Authorization: `Bearer ${token}`,
			},
			data = [],
			temp = [];

		//get Employee list for performance report
		this.getEmployeeList();
		//years list
		const years = [];
		let currentYear = new Date().getFullYear();

		do {
			years.unshift({
				value: empJoinedOn,
				label: empJoinedOn.toString(),
			});
			empJoinedOn++;
		} while (empJoinedOn != currentYear + 1);
		this.setState({
			yearList: years,
			selectedYear: { value: currentYear, label: currentYear.toString() },
		});

		//Team workstation
		axios
			.get(`${Dashboard_APIs.GetTeamWorkStationChart_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					TeamWorkStationData: res.data.teamWorkStations,
				});
				res.data.teamWorkStations.forEach((item, index) => {
					this.state.workFromOffice.push(item.workFromOffice);
					this.state.workFromHome.push(item.workFromHome);
				});
				let WFHCount = 0;
				let WFOCount = 0;
				let CWFOCount = 0;
				res.data.teamWorkStations.map((proj) => {
					WFHCount += proj.workFromHome;
					WFOCount += proj.workFromOffice;
					CWFOCount += proj.continuingWorkFromOffice;
				});
				this.setState({
					ALLEmployeeWSData: res.data.teamWorkStations.sort((a, b) =>
						a.employeeName.localeCompare(b.employeeName)
					),
				});
				let WFOdata = res.data.teamWorkStations.map((proj) => ({
					name: proj.employeeName,
					y: proj.workFromOffice,
					ws: proj.workFromHome,
					ws2: proj.continuingWorkFromOffice,
				}));
				let WFHdata = res.data.teamWorkStations.map((proj) => ({
					name: proj.employeeName,
					y: proj.workFromHome,
					ws: proj.workFromOffice,
					ws2: proj.continuingWorkFromOffice,
				}));
				let CWFOdata = res.data.teamWorkStations.map((proj) => ({
					name: proj.employeeName,
					y: proj.continuingWorkFromOffice,
					ws: proj.workFromOffice,
					ws2: proj.workFromHome,
				}));
				this.setState((prevState) => {
					let TeamWorkStationChartWFO = Object.assign(
						{},
						this.state.TeamWorkStationChartWFO
					);

					TeamWorkStationChartWFO.series[0].data = WFOdata;
					TeamWorkStationChartWFO.title.text = "WFO";
					TeamWorkStationChartWFO.subtitle.text = WFOCount;
					TeamWorkStationChartWFO.series[0].dataLabels.format =
						"{point.y:.0f}";
					TeamWorkStationChartWFO.tooltip.pointFormat = `<span style="font-weight:bold">WFO</span> {point.y:.0f} <br/> <span style="font-weight:bold">WFH</span> {point.ws:.0f} <br/> <span style="font-weight:bold">CWFO</span> {point.ws2:.0f}`;
					TeamWorkStationChartWFO.series[0].events.click = (
						event
					) => {
						let employee = res.data.teamWorkStations.find(
							(emp) => emp.employeeName === event.point.name
						);
						this.setState({
							showSpWorkStationModal: true,
							SpWorkStationModalEmp: employee,
						});
					};
					return { TeamWorkStationChartWFO };
				});
				this.setState((prevState) => {
					let TeamWorkStationChartWFH = Object.assign(
						{},
						this.state.TeamWorkStationChartWFH
					);

					TeamWorkStationChartWFH.series[0].data = WFHdata;
					TeamWorkStationChartWFH.title.text = "WFH";
					TeamWorkStationChartWFH.subtitle.text = WFHCount;
					TeamWorkStationChartWFH.series[0].dataLabels.format =
						"{point.y:.0f}";
					TeamWorkStationChartWFH.tooltip.pointFormat = `<span style="font-weight:bold">WFH</span> {point.y:.0f} <br/> <span style="font-weight:bold">WFO</span> {point.ws:.0f} <br/> <span style="font-weight:bold">CWFO</span> {point.ws2:.0f}`;
					TeamWorkStationChartWFH.series[0].events.click = (
						event
					) => {
						let employee = res.data.teamWorkStations.find(
							(emp) => emp.employeeName === event.point.name
						);
						this.setState({
							showSpWorkStationModal: true,
							SpWorkStationModalEmp: employee,
						});
					};
					return { TeamWorkStationChartWFH };
				});

				this.setState((prevState) => {
					let TeamWorkStationChartCWFO = Object.assign(
						{},
						this.state.TeamWorkStationChartCWFO
					);

					TeamWorkStationChartCWFO.series[0].data = CWFOdata;
					TeamWorkStationChartCWFO.title.text = "CWFO";
					TeamWorkStationChartCWFO.subtitle.text = CWFOCount;
					TeamWorkStationChartCWFO.series[0].dataLabels.format =
						"{point.y:.0f}";
					TeamWorkStationChartCWFO.tooltip.pointFormat = `<span style="font-weight:bold">CWFO</span> {point.y:.0f} <br/> <span style="font-weight:bold">WFH</span> {point.ws2:.0f} <br/> <span style="font-weight:bold">WFO</span> {point.ws:.0f}`;
					TeamWorkStationChartCWFO.series[0].events.click = (
						event
					) => {
						let employee = res.data.teamWorkStations.find(
							(emp) => emp.employeeName === event.point.name
						);
						this.setState({
							showSpWorkStationModal: true,
							SpWorkStationModalEmp: employee,
						});
					};
					return { TeamWorkStationChartCWFO };
				});
			});

		//GetDepartmentPendingTickets
		if (departmentIds.includes(department.toString())) {
			this.setState({
				ticketsLoading: true,
			});
			axios
				.get(`${Dashboard_APIs.GetDepartmentPendingTickets_API}`, {
					headers: headers,
				})
				.then((res) => {
					this.setState({
						ticketsLoading: false,
						pendingTickets: res.data.pendingTickets,
					});
				});
		}
		//GetTeamTimeSheetStatus_API
		axios
			.get(`${Dashboard_APIs.GetTeamTimeSheetStatus_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					pending:
						Number(res.data.pending) +
						Number(res.data.saved) +
						Number(res.data.inProgress),
					submitted: res.data.submitted,
					approved: res.data.approved,
					rejected: res.data.rejected,
					timesheetStatusLoading: false,
				});
			});
		//GetTeamLateCommingLateSitting_API
		axios
			.get(`${Dashboard_APIs.GetTeamLateCommingLateSitting_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					empLateComing: res.data.sort((a, b) =>
						a.empName.localeCompare(b.empName)
					),
				});
			});
		//GetTeamLeavesInfo_API
		axios
			.get(`${Dashboard_APIs.GetTeamLeavesInfo_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					empLeaves: res.data.sort((a, b) =>
						a.employee.localeCompare(b.employee)
					),
				});
			});

		//GetTeamCheckInCheckOut_API
		axios
			.get(`${Dashboard_APIs.GetTeamCheckInCheckOut_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					empCheckinCheckout: res.data.teamCheckInCheckOuts.sort(
						(a, b) => a.employeeName.localeCompare(b.employeeName)
					),
				});
			});

		//GetTeamWorkStationPercentage_API
		axios
			.get(`${Dashboard_APIs.GetTeamWorkStationPercentage_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					empWorkStationPercentage:
						res.data.myTeamWorkStationPercentages.sort((a, b) =>
							a.employeeName.localeCompare(b.employeeName)
						),
				});
			});

		//misc
		axios
			.get(`${Dashboard_APIs.GetTeamMiscTimeHours_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState((prevState) => {
					let miscPie = Object.assign({}, prevState.miscPie);
					miscPie.series[0].data = [
						{
							name: "Misc",
							y: parseInt(res.data.miscHours),
						},
					];
					miscPie.subtitle.text = res.data.miscHours;
					miscPie.series[0].dataLabels.format = "{point.y:.0f}";
					return { miscPie };
				});
			});
		//GetTeamLeavesandOffSiteWorkRequest
		axios
			.get(`${Dashboard_APIs.GetTeamLeavesandOffSiteWorkRequest_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					offSiteWorkrequests: res.data.offSiteWorkrequests,
					leavesRequests: res.data.leavesRequests,
					teamLeavesandOffSiteReqLoading: false,
				});
			});
		//GetTeamsOrganizationHoursSum
		axios
			.get(`${Dashboard_APIs.GetTeamsOrganizationHoursSum}`, {
				headers: headers,
			})
			.then((res) => {
				temp = res.data.hoursSpendOnProjects.filter(
					(proj) => proj.projectHours !== "0:0"
				);
				data = temp.map((proj) => ({
					name: proj.projectName,
					y:
						proj.projectHours !== "0:0" &&
						this.hoursToDecimal(proj.projectHours),
				}));

				this.setState((prevState) => {
					let orgPie = Object.assign({}, prevState.orgPie);
					orgPie.series[0].data = data;

					orgPie.subtitle.text =
						res.data.totalProjectHours < 10
							? "0" + res.data.totalProjectHours
							: res.data.totalProjectHours;

					orgPie.series[0].dataLabels.format = "{point.y:.0f}";
					orgPie.series[0].events.click = (event) => {
						//API call to get team for this org project which is clicked
						axios
							.get(
								`${Dashboard_APIs.GetTeamHoursSpentOnTask_API}1&TaskName=${event.point.name}`,
								{
									headers: headers,
								}
							)
							.then((res) => {
								//
								this.open(event.point.name, res.data);
							});
					};
					return { orgPie };
				});
			});
		//GetTeamPresaleHoursSum
		axios
			.get(`${Dashboard_APIs.GetTeamPresaleHoursSum}`, {
				headers: headers,
			})
			.then((res) => {
				temp = res.data.hoursSpendOnProjects.filter(
					(proj) => proj.projectHours !== "0:0"
				);
				data = temp.map((proj) => ({
					name: proj.projectName,
					y:
						proj.projectHours !== "0:0" &&
						this.hoursToDecimal(proj.projectHours),
				}));

				this.setState((prevState) => {
					let preSalesPie = Object.assign({}, prevState.preSalesPie);
					preSalesPie.series[0].data = data;

					preSalesPie.subtitle.text =
						res.data.totalProjectHours < 10
							? "0" + res.data.totalProjectHours
							: res.data.totalProjectHours;
					preSalesPie.series[0].dataLabels.format = "{point.y:.0f}";
					preSalesPie.series[0].events.click = (event) => {
						//API call to get team for this presales project which is clicked

						axios
							.get(
								`${Dashboard_APIs.GetTeamHoursSpentOnTask_API}0&TaskName=${event.point.name}`,
								{
									headers: headers,
								}
							)
							.then((res) => {
								//
								this.open(event.point.name, res.data);
							});
					};
					return { preSalesPie };
				});
			});
		//Get Project Team Size
		axios
			.get(`${Dashboard_APIs.ProjectTeamSize_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					...this.state,
					projectTeam: res.data,
				});
			});
		//GetTeamsProjectHoursSum_API
		axios
			.get(`${Dashboard_APIs.GetTeamsProjectHoursSum_API}`, {
				headers: headers,
			})
			.then((res) => {
				temp = res.data.hoursSpendOnProjects.filter(
					(proj) => proj.projectHours !== "0:0"
				);
				data = temp.map((proj) => ({
					name: proj.projectName,
					y:
						proj.projectHours !== "0:0" &&
						this.hoursToDecimal(proj.projectHours),
				}));

				this.setState((prevState) => {
					let projectsPie = Object.assign({}, prevState.projectsPie);
					projectsPie.series[0].data = data;

					projectsPie.subtitle.text =
						res.data.totalProjectHours < 10
							? "0" + res.data.totalProjectHours
							: res.data.totalProjectHours;
					projectsPie.series[0].dataLabels.format = "{point.y:.0f}";

					projectsPie.series[0].events.click = (event) => {
						//API call to get team for this project which is clicked
						axios
							.get(
								`${Dashboard_APIs.TeamProjectResourceList_API}${event.point.name}`,
								{
									headers: headers,
								}
							)
							.then((res) => {
								this.open(event.point.name, res.data);
							});
					};
					return { projectsPie };
				});
			});

		//Get timesheetPerformanceData for pie chart
		this.getTimesheetPerformanceAPI(currentYear, 0, 0);

		//Get timesheetPerformanceData for line graph
		this.getTimesheetPerformanceLineChartAPI(currentYear, 0, 0);
	}
	hoursToDecimal = (time) => {
		let a = time.split(":"); // split it at the colons
		for (let i = 0; i < a.length; i++) a[i] = parseInt(a[i]);
		let dec = a[0] + Math.floor(a[1] / 60);

		return dec;
	};
	handleClose = () => {
		this.setState({ showModal: false });
	};

	open = (currProj, projData) => {
		this.setState({
			currProj: currProj,
			projData: projData,
			showModal: true,
		});
	};
	getTimeSheetStatus = (obj) => {
		this.props.UpdateNavBarItem("SpTimeSheetStatus");
		this.props.UpdateNavBarTab("SupervisorTasks");
		sessionStorage.setItem("NavbarTab", "SupervisorTasks");
		sessionStorage.setItem("NavbarItem", "SpTimeSheetStatus");
		return this.props.history?.push(`/SpTimeSheetStatus/${obj}`);
	};

	redirectionFromDashboardTo = (
		navBarItem,
		navBarTab,
		route,
		stateName,
		stateValue,
		search
	) => {
		UpdateNavBarItem(navBarItem);
		UpdateNavBarTab(navBarTab);
		sessionStorage.setItem("NavbarTab", navBarTab);
		sessionStorage.setItem("NavbarItem", navBarItem);
		if (stateName) {
			if (search)
				return this.props.history?.push({
					pathname: route,
					search: search,
					state: {
						[stateName]: stateValue,
					},
				});
			else
				return this.props.history?.push({
					pathname: route,
					state: {
						[stateName]: stateValue,
					},
				});
		} else if (route) {
			return this.props.history?.push(route);
		}
	};

	getEmployeeList = () => {
		if (
			department === "5" || //Accounts
			department === "9" || //Admin
			empDesignation?.toString() === "4" || //CM
			employeeId?.toString() === "180" || //Abdullah
			employeeId?.toString() === "42" || //Umer khan
			employeeId?.toString() == "232" /*Moazzam*/
		) {
			axios
				.get(`${Dashboard_APIs.GetEmployeeList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					this.setState({
						employeesList: list,
						selectedEmployee: allEmp,
					});
				});
		} else {
			axios
				.get(`${Dashboard_APIs.GetSupervisorsEmployeesList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					this.setState({
						employeesList: list,
						selectedEmployee: allEmp,
					});
				});
		}
	};
	getTimesheetPerformanceAPI = (year, month, employee) => {
		let chartObj = this?.timehseetPiechart?.current?.chart;

		if (chartObj) {
			chartObj.showLoading();
			chartObj.drillUp();
		}
		this.setState({
			TimesheetPerformanceSelectedGrouBy: groupByList[0],
		});

		axios
			.get(
				`${
					Dashboard_APIs.GetMyTeamTimesheetScorePieChart
				}?Year=${year}&Month=${month}&EmployeeId=${employee || 0}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				let temp2 = res.data.scoreCollection;
				let history = this.props.history;
				let chartSelectedMonth = this.state.selectedMonth;
				let chartSelectedYear = this.state.selectedYear;

				let drillDownScoreDetail = temp2.map((rec) => {
					return {
						dataLabels: {
							enabled: true,
							format: "{point.y}",
							distance: -30,
							style: {
								fontFamily: "Poppins",
								fontWeight: "bold",
								fontSize: "15px",
								color: "white",
								stroke: "none",
								fill: "none",
								opacity: 1,
							},
							useHTML: true,
							formatter: function () {
								let labelValue =
									this.value +
									"<span>&times;</span>10^" +
									this.value;
								return labelValue;
							},
						},
						name: rec.score,
						id: rec.score,
						data: rec.employees.map((item) => {
							return {
								name: item.employeeName,
								y: item.count,
								dataLabels: {
									enabled: true,
								},
								events: {
									click: function (event) {
										history.push({
											pathname:
												Routes.TimesheetPerformanceReport,
											search: "?emp=" + item.employeeId,
											state: {
												empName: item.employeeName,
												empId: item.employeeId,
												score: rec.numericScore,
												month: chartSelectedMonth,
												year: chartSelectedYear,
											},
										});
									},
								},
							};
						}),
						showInLegend: true,
					};
				});
				let FMECount = 0;
				let MEMinusCount = 0;
				let MECount = 0;
				let MEPlusCount = 0;
				let MEECount = 0;
				let ScoreCollectoion = [];

				temp2.map((item) => {
					if (item.score != "None" && item.numericScore != -1) {
						switch (item.numericScore) {
							case 1:
								FMECount = item.employees.length;
								break;
							case 2:
								MEMinusCount = item.employees.length;
								break;
							case 3:
								MECount = item.employees.length;
								break;
							case 4:
								MEPlusCount = item.employees.length;
								break;
							case 5:
								MEECount = item.employees.length;
								break;
							default:
								break;
						}
					}
				});
				ScoreCollectoion.push(
					{
						name: "MEE",
						drilldown: "MEE",
						y: MEECount,
					},
					{
						name: "ME+",
						drilldown: "ME+",
						y: MEPlusCount,
					},
					{
						name: "ME",
						drilldown: "ME",
						y: MECount,
					},
					{
						name: "ME-",
						drilldown: "ME-",
						y: MEMinusCount,
					},
					{
						name: "FME",
						drilldown: "FME",
						y: FMECount,
					}
				);
				this.setState((prevState) => {
					let timesheetPerformanceChart = Object.assign(
						{},
						prevState.timesheetPerformanceChart
					);
					timesheetPerformanceChart.series[0].data = ScoreCollectoion;
					timesheetPerformanceChart.drilldown.series =
						drillDownScoreDetail;
					timesheetPerformanceChart.series[0].dataLabels.format = `<span style="font-weight:bold;color:white;text-decoration:none">{point.name}</span><br/><span style="font-weight:bold;color:white;text-decoration:none">{point.y:.0f}</span> `;

					this.setState({
						timesheetPerformancePieChartLoading: false,
					});
					if (chartObj) chartObj.hideLoading();
					return { timesheetPerformanceChart };
				});
			});
	};
	getTimesheetPerformanceLineChartAPI = (year, month, employee, groupBy) => {
		let label = "";
		this.state.TimesheetPerformanceMEE = [];
		this.state.TimesheetPerformanceMEPlus = [];
		this.state.TimesheetPerformanceME = [];
		this.state.TimesheetPerformanceMEMinus = [];
		this.state.TimesheetPerformanceFME = [];
		this.state.TimesheetPerformanceCategories = [];
		let chartObj = this?.TimesheetPerLinechart?.current?.chart;

		if (chartObj) chartObj.showLoading();

		let apiUrl = `${
			Dashboard_APIs.GetMyTeamTimesheetScoreLineChart
		}?Month=${month}&Year=${year}&EmployeeId=${employee}&GroupBy=${
			groupBy || 1
		}`;
		axios
			.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				res.data.timesheetScoreObjects.forEach((item, index) => {
					if (groupBy === 2) {
						this.state.TimesheetPerformanceCategories.push(
							item.title
						);
					} else {
						this.state.TimesheetPerformanceCategories.push(
							moment(item.title).format("DD MMMM YY")
						);
					}

					item.scoreList.map((score) => {
						let scoreObj = {
							name: score.score,
							y: score.count,
						};
						switch (score.numericScore) {
							case 5:
								this.state.TimesheetPerformanceMEE.push(
									scoreObj
								);
								break;
							case 4:
								this.state.TimesheetPerformanceMEPlus.push(
									scoreObj
								);
								break;
							case 3:
								this.state.TimesheetPerformanceME.push(
									scoreObj
								);
								break;
							case 2:
								this.state.TimesheetPerformanceMEMinus.push(
									scoreObj
								);
								break;
							case 1:
								this.state.TimesheetPerformanceFME.push(
									scoreObj
								);
								break;
							default:
								break;
						}
					});
				});

				let component = this;
				let MEE = {
					name: "MEE",
					data: this.state.TimesheetPerformanceMEE,
					marker: this.state.marker,
					events: {
						click: function (event) {
							return component.redirectionFromDashboardTo(
								"TimesheetPerformanceReport",
								"SupervisorTasks",
								groupBy === 2 && //Month
									Routes.TimesheetPerformanceReport,
								groupBy === 2 //Month
									? "monthTPRRedirection"
									: "weekTPRredirection",
								moment(event.point.category).format(
									"DD/MM/YYYY"
								)
							);
						},
					},
				};
				let MEPlus = {
					name: "ME+",
					data: this.state.TimesheetPerformanceMEPlus,
					marker: this.state.marker,
					events: {
						click: function (event) {
							return component.redirectionFromDashboardTo(
								"TimesheetPerformanceReport",
								"SupervisorTasks",
								groupBy === 2 && //Month
									Routes.TimesheetPerformanceReport,
								groupBy === 2 //Month
									? "monthTPRRedirection"
									: "weekTPRredirection",
								moment(event.point.category).format(
									"DD/MM/YYYY"
								)
							);
						},
					},
				};
				let ME = {
					name: "ME",
					data: this.state.TimesheetPerformanceME,
					marker: this.state.marker,
					events: {
						click: function (event) {
							return component.redirectionFromDashboardTo(
								"TimesheetPerformanceReport",
								"SupervisorTasks",
								groupBy === 2 && //Month
									Routes.TimesheetPerformanceReport,
								groupBy === 2 //Month
									? "monthTPRRedirection"
									: "weekTPRredirection",
								moment(event.point.category).format(
									"DD/MM/YYYY"
								)
							);
						},
					},
				};
				let MEMinus = {
					name: "ME-",
					data: this.state.TimesheetPerformanceMEMinus,
					marker: this.state.marker,
					events: {
						click: function (event) {
							return component.redirectionFromDashboardTo(
								"TimesheetPerformanceReport",
								"SupervisorTasks",
								groupBy === 2 && //Month
									Routes.TimesheetPerformanceReport,
								groupBy === 2 //Month
									? "monthTPRRedirection"
									: "weekTPRredirection",
								moment(event.point.category).format(
									"DD/MM/YYYY"
								)
							);
						},
					},
				};
				let FME = {
					name: "FME",
					data: this.state.TimesheetPerformanceFME,
					marker: this.state.marker,
					events: {
						click: function (event) {
							return component.redirectionFromDashboardTo(
								"TimesheetPerformanceReport",
								"SupervisorTasks",
								groupBy === 2 && //Month
									Routes.TimesheetPerformanceReport,
								groupBy === 2 //Month
									? "monthTPRRedirection"
									: "weekTPRredirection",
								moment(event.point.category).format(
									"DD/MM/YYYY"
								)
							);
						},
					},
				};
				this.setState((prevState) => {
					let TimesheetPerformanceLineChart = Object.assign(
						{},
						prevState.TimesheetPerformanceLineChart
					);
					TimesheetPerformanceLineChart.xAxis.categories =
						this.state.TimesheetPerformanceCategories;

					TimesheetPerformanceLineChart.xAxis.title = {
						text: label + " " + year,
					};
					TimesheetPerformanceLineChart.series = [];
					TimesheetPerformanceLineChart.series.push(
						MEE,
						MEPlus,
						ME,
						MEMinus,
						FME
					);
					return { TimesheetPerformanceLineChart };
				});
				this.setState({
					timesheetPerformanceLineChartLoading: false,
				});
				if (chartObj) chartObj.hideLoading();
			});
	};
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					employeeId = userDetails.id;
					empDesignation = userDetails.designation;
					department = userDetails.department;
					empJoinedOn = userDetails.empJoinedOn.split("-")[0];
					return (
						<div className="container-fluid pl-4 pr-4">
							<Header title={title(userDetails)} />
							<Modal
								show={this.state.showModal}
								onHide={this.handleClose}
								aria-labelledby="contained-modal-title-vcenter"
								centered
								size="xl"
								className="project-modal"
							>
								<Modal.Header closeButton>
									{this.state.currProj.toUpperCase()}
								</Modal.Header>
								<Modal.Body className="modal-body">
									{this.state.projData.length !== 0 ? (
										<div>
											<Table>
												<thead>
													<tr>
														<th>EMPLOYEE NAME</th>
														<th>PROJECT HOURS</th>
													</tr>
												</thead>
												{this.state.projData.map(
													(item, i) => (
														<tbody key={i}>
															<tr
																className={
																	i % 2 === 0
																		? "bgColor1"
																		: "bgColor2"
																}
															>
																<td>
																	<Link to="">
																		{
																			item.name
																		}
																	</Link>
																</td>
																<td>
																	{
																		item.timeSpent
																	}
																</td>
															</tr>
														</tbody>
													)
												)}
											</Table>
										</div>
									) : (
										<div className="text-center">
											{" "}
											No data to show
										</div>
									)}
								</Modal.Body>
							</Modal>
							<SpWorkStationModal
								showSpWorkStationModal={
									this.state.showSpWorkStationModal
								}
								handleClose={() => {
									this.setState({
										showSpWorkStationModal: false,
									});
								}}
								SpWorkStationModalEmp={
									this.state.SpWorkStationModalEmp
								}
								ALLEmployeeWSData={this.state.ALLEmployeeWSData}
								onshowALLEmployeeWSDataClick={() =>
									this.setState({
										showALLEmployeeWSData:
											!this.state.showALLEmployeeWSData,
									})
								}
								showALLEmployeeWSData={
									this.state.showALLEmployeeWSData
								}
							/>
							<div className="container-fluid">
								<div className="row mt-5 contentClass">
									<div className="col-sm-12 col-md-12 col-lg-12 mb-3 title ">
										Last 5 Weeks Timesheet Status
									</div>
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div
											className="col-md-12 mt-2 mt-lg-0 styleDiv1 spPending-div"
											onClick={() => {
												this.getTimeSheetStatus(1);
											}}
										>
											<div className="mt-2 px-0 statusLeave">
												Pending
											</div>
											<div className="leaveCount mt-4">
												{this.state
													.timesheetStatusLoading ? (
													<Spinner className="mt-2" />
												) : this.state.pending < 10 ? (
													"0" + this.state.pending
												) : (
													this.state.pending
												)}
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div
											className="col-md-12 mt-2 mt-lg-0 styleDiv2 spSubmitted-div"
											onClick={() => {
												this.getTimeSheetStatus(
													3,
													"Submitted"
												);
											}}
										>
											<div className="mt-2 px-0 statusLeave">
												Submitted
											</div>
											<div className="leaveCount mt-4">
												{this.state
													.timesheetStatusLoading ? (
													<Spinner className="mt-2" />
												) : this.state.submitted <
												  10 ? (
													"0" + this.state.submitted
												) : (
													this.state.submitted
												)}
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div
											className="col-md-12 mt-2 mt-lg-0 styleDiv3 spApprove-div"
											onClick={() => {
												this.getTimeSheetStatus(
													4,
													"Approved"
												);
											}}
										>
											<div className="mt-2 px-0 statusLeave">
												Approved
											</div>
											<div className="leaveCount mt-4">
												{this.state
													.timesheetStatusLoading ? (
													<Spinner className="mt-2" />
												) : this.state.approved < 10 ? (
													"0" + this.state.approved
												) : (
													this.state.approved
												)}
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div
											className="col-md-12 mt-2 mt-lg-0 styleDiv4 spRejected-div"
											onClick={() => {
												this.getTimeSheetStatus(
													5,
													"Rejected"
												);
											}}
										>
											<div className="mt-2 px-0 statusLeave">
												Rejected
											</div>
											<div className="leaveCount mt-4">
												{this.state
													.timesheetStatusLoading ? (
													<Spinner className="mt-2" />
												) : this.state.rejected < 10 ? (
													"0" + this.state.rejected
												) : (
													this.state.rejected
												)}
											</div>
										</div>
									</div>
								</div>
								<div className="col col-md-12 mb-3 px-2 mt-4 mx-1 workStationChartWrapper">
									<div className="p-3 title">
										Team Work Station
										<span className="small">
											{"\xa0\xa0(Current\xa0Month)"}
										</span>
									</div>

									<Row>
										<div
											className="col col-xl-4 col-lg-12 col-md-12 col-sm-12 "
											id="SpTeamWorkStationChart"
										>
											<PieChart
												highcharts={Highcharts}
												options={
													this.state
														.TeamWorkStationChartWFO
												}
											/>
										</div>
										<div
											className="col col-xl-4 col-lg-12 col-md-12 col-sm-12 "
											id="SpTeamWorkStationChart"
										>
											<PieChart
												highcharts={Highcharts}
												options={
													this.state
														.TeamWorkStationChartWFH
												}
											/>
										</div>
										<div
											className="col col-xl-4 col-lg-12 col-md-12 col-sm-12 "
											id="SpTeamWorkStationChart"
										>
											<PieChart
												highcharts={Highcharts}
												options={
													this.state
														.TeamWorkStationChartCWFO
												}
											/>
										</div>
									</Row>
								</div>
								<div className="row mt-4 contentClass ">
									<div className="col-sm-12 col-md-6 mt-2">
										<div className="col-md-12 mt-md-0 h-100 graphDiv1 tableScroll">
											<div className="m-2 pt-3 pb-3 title">
												Current Month Late
												Comings/Sittings
											</div>
											{this.state.empLateComing.length !==
											0 ? (
												<Table
													responsive
													hover
													className="text-center"
												>
													<thead>
														<tr className="tableRowColor">
															<th>
																Employee Name
															</th>
															<th>
																Late Sittings
															</th>
															<th>
																Late Comings
															</th>
														</tr>
													</thead>

													{this.state.empLateComing.map(
														(item, key) => (
															<tbody
																key={item.empId}
															>
																<tr
																	className={`SpTeamClickableWidget ${
																		key %
																			2 ===
																		0
																			? "bgColor1"
																			: "bgColor2"
																	}`}
																	onClick={() => {
																		this.redirectionFromDashboardTo(
																			"spOffsiteWorkHours",
																			"SupervisorTasks",
																			`/CheckInCheckOut`,
																			"redirectedState",
																			{
																				value: 10,
																				label: "Late Coming & Sitting",
																			},
																			`?Employee=${item.empId}`
																		);
																	}}
																>
																	<td>
																		{
																			item.empName
																		}
																	</td>
																	<td
																		className={
																			item.lateSittingCount <
																			8
																				? "font-blue"
																				: "font-red"
																		}
																	>
																		{
																			item.lateSittingCount
																		}
																	</td>
																	<td
																		className={
																			item.lateCommingCount <
																			8
																				? "font-blue"
																				: "font-red"
																		}
																	>
																		{
																			item.lateCommingCount
																		}
																	</td>
																</tr>
															</tbody>
														)
													)}
												</Table>
											) : (
												<div className="text-center">
													{" "}
													No data found{" "}
												</div>
											)}
										</div>
									</div>
									<div className="col-sm-12 col-md-6 mt-2">
										<div className="col-md-12 mt-4 mt-md-0 h-100 graphDiv2  tableScroll">
											<div className="m-2 pt-3 pb-3 title">
												Team Leaves Info
											</div>
											{this.state.empLeaves.length !==
											0 ? (
												<Table
													responsive
													hover
													className="text-center"
												>
													<thead>
														<tr className="tableRowColor">
															<th>
																Employee Name
															</th>
															<th>
																Available Leaves
															</th>
															<th>
																Planned Leaves
															</th>
														</tr>
													</thead>
													{this.state.empLeaves.map(
														(item, i) => (
															<tbody
																key={item.empId}
															>
																<tr
																	className={`SpTeamClickableWidget ${
																		i %
																			2 ===
																		0
																			? "bgColor1"
																			: "bgColor2"
																	}`}
																	onClick={() => {
																		this.redirectionFromDashboardTo(
																			"ResourceLeavesInfo",
																			"SupervisorTasks",
																			`/ResourceLeavesInfo/${item.empId}`,
																			"employeeLeaveListingRedirection",
																			true
																		);
																	}}
																>
																	<td>
																		{
																			item.employee
																		}
																	</td>
																	<td>
																		{
																			item.availableAnnualLeaves
																		}
																	</td>
																	<td>
																		{
																			item.futureLeaves
																		}
																	</td>
																</tr>
															</tbody>
														)
													)}
												</Table>
											) : (
												<div className="text-center mt-2">
													{" "}
													No data found{" "}
												</div>
											)}
										</div>
									</div>
								</div>
								<div className="row mt-4 contentClass ">
									<div className="col-sm-12 col-md-6 mt-2">
										<div className="col-md-12 mt-md-0 h-100 graphDiv1 tableScroll">
											<div className="m-2 pt-3 pb-3 title">
												Team Work Station
												<span className="small">
													{
														"\xa0\xa0(Current\xa0Month)"
													}
												</span>
											</div>
											{this.state.empWorkStationPercentage
												.length !== 0 ? (
												<Table
													responsive
													hover
													className="text-center"
												>
													<thead>
														<tr className="tableRowColor">
															<th>
																Employee Name
															</th>
															<th>
																Work From Office
															</th>
															<th>
																Work From Home
															</th>
														</tr>
													</thead>

													{this.state
														.empWorkStationPercentage &&
														this.state.empWorkStationPercentage.map(
															(item, key) => (
																<tbody
																	key={
																		item.employeeId
																	}
																>
																	<tr
																		className={`SpTeamClickableWidget ${
																			key %
																				2 ===
																			0
																				? "bgColor1"
																				: "bgColor2"
																		}`}
																		onClick={() => {
																			this.redirectionFromDashboardTo(
																				"spOffsiteWorkHours",
																				"SupervisorTasks",
																				`/CheckInCheckOut?Employee=${item.employeeId}`
																			);
																		}}
																	>
																		<td>
																			{
																				item.employeeName
																			}
																		</td>
																		<td>
																			{item.workFromOfficePercentage &&
																			typeof item.workFromOfficePercentage ===
																				"number"
																				? item.workFromOfficePercentage.toFixed(
																						1
																				  ) +
																				  "%"
																				: item.workFromOfficePercentage +
																				  "%"}
																		</td>
																		<td>
																			{item.workFromHomePercentage &&
																			typeof item.workFromHomePercentage ===
																				"number"
																				? item.workFromHomePercentage.toFixed(
																						1
																				  ) +
																				  "%"
																				: item.workFromHomePercentage +
																				  "%"}
																		</td>
																	</tr>
																</tbody>
															)
														)}
												</Table>
											) : (
												<div className="text-center">
													{" "}
													No data found{" "}
												</div>
											)}
										</div>
									</div>
									<div className="col-sm-12 col-md-6 mt-2">
										<div className="col-md-12 mt-4 mt-md-0 h-100 graphDiv2  tableScroll">
											<div className="m-2 pt-3 pb-3 title">
												Team Checkin Checkout
												<span className="small">
													{"\xa0\xa0(Today)"}
												</span>
											</div>
											{this.state.empCheckinCheckout
												.length !== 0 ? (
												<Table
													responsive
													hover
													className="text-center"
												>
													<thead>
														<tr className="tableRowColor">
															<th>
																Employee Name
															</th>
															<th>Checkin</th>
															<th>Checkout</th>
														</tr>
													</thead>
													{this.state.empCheckinCheckout.map(
														(item, i) => (
															<tbody
																key={
																	item.employeeId
																}
															>
																<tr
																	className={`SpTeamClickableWidget ${
																		i %
																			2 ===
																		0
																			? "bgColor1"
																			: "bgColor2"
																	}`}
																	onClick={() => {
																		this.redirectionFromDashboardTo(
																			"spOffsiteWorkHours",
																			"SupervisorTasks",
																			`/CheckInCheckOut?Emp=${item.employeeId}`
																		);
																	}}
																>
																	<td>
																		{
																			item.employeeName
																		}
																	</td>
																	<td>
																		{item.checkedInAt
																			? moment(
																					item.checkedInAt
																			  ).format(
																					"HH:mm"
																			  )
																			: "N/A"}
																		{item.checkedInFromOffice !=
																		null ? (
																			item.checkedInFromOffice ===
																			true ? (
																				<Image
																					src={
																						officeIcon
																					}
																					className="officeIcon"
																					alt="office"
																					title="Checkin from Office"
																				/>
																			) : (
																				<Image
																					src={
																						homeIcon
																					}
																					className="homeIcon"
																					alt="home"
																					title="Checkin from Home"
																				/>
																			)
																		) : null}
																	</td>
																	<td>
																		{item.checkedOutAt
																			? moment(
																					item.checkedOutAt
																			  ).format(
																					"HH:mm"
																			  )
																			: "N/A"}
																		{item.checkoutOutFromOffice !=
																		null ? (
																			item.checkoutOutFromOffice ===
																			true ? (
																				<Image
																					src={
																						officeIcon
																					}
																					className="officeIcon"
																					alt="office"
																					title="Checkout from Office"
																				/>
																			) : (
																				<Image
																					src={
																						homeIcon
																					}
																					className="homeIcon"
																					alt="home"
																					title="Checkout from Home"
																				/>
																			)
																		) : null}
																	</td>
																</tr>
															</tbody>
														)
													)}
												</Table>
											) : (
												<div className="text-center mt-2">
													{" "}
													No data found{" "}
												</div>
											)}
										</div>
									</div>
								</div>
								<div className="row mt-5 contentClass">
									<div className="col-lg-6 col-sm-12">
										<div className="row contentClass">
											<div className="col-lg-6 col-md-6 col-sm-12">
												<div
													className="col-md-12 mt-2 mt-lg-0 leaveRow1"
													onClick={() => {
														sessionStorage.setItem(
															"NavbarTab",
															"SupervisorTasks"
														);
														sessionStorage.setItem(
															"NavbarItem",
															"SpReviewLeave"
														);
														this.props.history.push(
															Routes.SpReviewLeave
														);
														this.props.UpdateNavBarItem(
															"SpReviewLeave"
														);
														this.props.UpdateNavBarTab(
															"SupervisorTasks"
														);
													}}
												>
													<div className="title p-2">
														Team Leaves Review
													</div>
													<div className="leaveCount2 p-3">
														{this.state
															.teamLeavesandOffSiteReqLoading ? (
															<Loader className="mt-2" />
														) : this.state
																.leavesRequests <
														  10 ? (
															"0" +
															this.state
																.leavesRequests
														) : (
															this.state
																.leavesRequests
														)}
													</div>
												</div>
											</div>

											<div className="col-lg-6 col-md-6 col-sm-12">
												<div
													className="col-md-12 mt-2 mt-lg-0 leaveRow2"
													style={{
														cursor: "pointer",
													}}
													onClick={() => {
														sessionStorage.setItem(
															"NavbarTab",
															"SupervisorTasks"
														);
														sessionStorage.setItem(
															"NavbarItem",
															"spOffsiteWorkHours"
														);
														this.props.history.push(
															Routes.spOffsiteWorkHours
														);
														this.props.UpdateNavBarItem(
															"spOffsiteWorkHours"
														);
														this.props.UpdateNavBarTab(
															"SupervisorTasks"
														);
													}}
												>
													<div className="title p-2">
														Offsite Work Hours
													</div>
													<div className="leaveCount2 p-3">
														{this.state
															.teamLeavesandOffSiteReqLoading ? (
															<Loader className="mt-2" />
														) : this.state
																.offSiteWorkrequests <
														  10 ? (
															"0" +
															this.state
																.offSiteWorkrequests
														) : (
															this.state
																.offSiteWorkrequests
														)}
													</div>
												</div>
											</div>
										</div>
										<div className="row mt-5 contentClass">
											<div className="col-lg-6 col-md-6 col-sm-12">
												<div
													className="col-md-12 mt-2 mt-lg-0 leaveRow3"
													style={{
														cursor: "pointer",
													}}
													onClick={() => {
														departmentIds.includes(
															department.toString()
														) &&
															this.props.UpdateNavBarItem(
																"ResourceTickets"
															);
														this.props.UpdateNavBarTab(
															"GeneralTasks"
														);
														this.props.history.push(
															Routes.DepartmentTicketListing
														);
													}}
												>
													<div className="statusLeave p-2 font-small">
														My Department Tickets
													</div>
													<div className="leaveCount1 p-3">
														{this.state
															.ticketsLoading ? (
															<Spinner className="mt-2" />
														) : this.state
																.pendingTickets <
														  10 ? (
															"0" +
															this.state
																.pendingTickets
														) : (
															this.state
																.pendingTickets
														)}
													</div>
												</div>
											</div>
											<div className="col-lg-6 col-md-6 col-sm-12">
												<div className="col-md-12 mt-2 mt-lg-0 leaveRow4">
													<div className="statusLeave p-2 font-small">
														Team Open Tickets
													</div>
													<div className="leaveCount1 p-3">
														00
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-lg-6 col-sm-12">
										<ProjectTeam
											teamSize={this.state.projectTeam}
										/>
									</div>
								</div>

								<div className=" row mt-5 contentClass">
									<div className="col-md-12 col-sm-12 p-3 title">
										Monthly Hours Spent on
									</div>
									<div className="col-sm-12 col-md-6">
										<div className="col-md-12 mt-2 mt-md-0 SpGraphDiv1 h-75">
											<div className="p-3 title">
												Projects
											</div>
											<div id="SpProjectsChart">
												<PieChart
													highcharts={Highcharts}
													options={
														this.state.projectsPie
													}
												/>
											</div>
										</div>
									</div>
									<div className="col-sm-12 col-md-6">
										<div className="col-md-12 mt-2 mt-md-0 SpGraphDiv2 h-75">
											<div className="p-3 title">
												Organizations
											</div>
											<div id="SpOrganizationChart">
												<PieChart
													highcharts={Highcharts}
													options={this.state.orgPie}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className=" row marginClassSpecific contentClass">
									<div className="col-sm-12 col-md-6">
										<div className="col-md-12 mt-2 mt-md-0 SpGraphDiv1 h-75">
											<div className="p-3 title">
												Misc. time
											</div>
											<div id="SpMiscTimeChart">
												<PieChart
													highcharts={Highcharts}
													options={this.state.miscPie}
												/>
											</div>
										</div>
									</div>
									<div className="col-sm-12 col-md-6">
										<div className="col-md-12 mt-2 mt-md-0 SpGraphDiv2 h-75">
											<div className="p-3 title">
												Sales/Presales
											</div>
											<div id="SpSalesChart">
												<PieChart
													id="SpSalesChart"
													highcharts={Highcharts}
													options={
														this.state.preSalesPie
													}
												/>
											</div>
										</div>
									</div>
								</div>

								<div
									className="contentClass"
									style={{ marginTop: "-10px" }}
								>
									<Row className="mb-1 align-items-baseline ">
										<div className="ml-2 col-md-3 col-sm-3 p-2 title">
											Timesheets Performance Report
										</div>
										<Col className="d-flex align-items-baseline justify-content-end">
											<Label className="mr-2">
												Year:{" "}
											</Label>
											<div
												className="mr-3"
												style={{
													zIndex: 100,
												}}
											>
												<CustomReactSelect
													className="CMYearDropdown"
													options={
														this.state.yearList
													}
													onChange={(event) => {
														let value = event.value;
														this.setState({
															selectedYear: {
																value: value,
																label: value.toString(),
															},
														});
														this.getTimesheetPerformanceAPI(
															value,
															this.state
																.selectedMonth
																.value,
															this.state
																.selectedEmployee
																.value,
															"onYearChange"
														);
														this.getTimesheetPerformanceLineChartAPI(
															value,
															this.state
																.selectedMonth
																.value,
															this.state
																.selectedEmployee
																.value
														);
													}}
													value={
														this.state.selectedYear
													}
													placeholder="Employee"
													paginationDropDown={true}
												/>
											</div>
											<Label className="mr-2">
												Month:{" "}
											</Label>
											<div
												className="mr-3"
												style={{
													zIndex: 100,
												}}
											>
												<CustomReactSelect
													className="CMYearDropdown"
													placeholder="Month"
													options={monthsList}
													value={
														this.state.selectedMonth
													}
													paginationDropDown={true}
													onChange={(event) => {
														let value = event.value;
														this.setState({
															selectedMonth:
																event,
														});
														this.getTimesheetPerformanceAPI(
															this.state
																.selectedYear
																.value,
															value,
															this.state
																.selectedEmployee
																.value,
															"onMonthChange"
														);
														this.getTimesheetPerformanceLineChartAPI(
															this.state
																.selectedYear
																.value,
															value,
															this.state
																.selectedEmployee
																.value
														);
													}}
												/>
											</div>
											<Label className="mr-2">
												Employee:{" "}
											</Label>
											<div
												className="mr-2"
												style={{
													zIndex: 100,
												}}
											>
												<CustomReactSelect
													className="CMYearDropdown"
													paginationDropDown={true}
													options={
														this.state.employeesList
													}
													value={
														this.state
															.selectedEmployee
													}
													onChange={(event) => {
														let value = event.value;
														this.setState({
															selectedEmployee:
																event,
														});
														this.getTimesheetPerformanceAPI(
															this.state
																.selectedYear
																.value,
															this.state
																.selectedMonth
																.value,
															value,
															"onEmployeeChange"
														);
														this.getTimesheetPerformanceLineChartAPI(
															this.state
																.selectedYear
																.value,
															this.state
																.selectedMonth
																.value,
															value
														);
													}}
												/>
											</div>
										</Col>
									</Row>
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 cmGraphs ">
										{this.state
											.timesheetPerformancePieChartLoading ? (
											<div className="graphLoadingSpinner">
												<Spinner />
											</div>
										) : (
											<PieChart
												highcharts={Highcharts}
												options={
													this.state
														.timesheetPerformanceChart
												}
												ref={this.timehseetPiechart}
											/>
										)}
									</div>
									<div
										className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 cmGraphs "
										style={{ marginTop: "-10px" }}
									>
										<Row className="ml-3 d-flex align-items-baseline justify-content-end mr-2">
											<Label className="mr-2">
												Group By:{" "}
											</Label>
											<CustomReactSelect
												className="CMYearDropdown"
												paginationDropDown={true}
												options={groupByList}
												value={
													this.state
														.TimesheetPerformanceSelectedGrouBy
												}
												onChange={(event) => {
													let value = event.value;
													this.setState({
														TimesheetPerformanceSelectedGrouBy:
															event,
													});
													this.getTimesheetPerformanceLineChartAPI(
														this.state.selectedYear
															.value,
														this.state.selectedMonth
															.value,
														this.state
															.selectedEmployee
															.value,
														value,
														"onGroupByChange"
													);
												}}
											/>
										</Row>
										{this.state
											.timesheetPerformanceLineChartLoading ? (
											<div className="graphLoadingSpinner">
												<Spinner />
											</div>
										) : (
											<PieChart
												highcharts={Highcharts}
												options={
													this.state
														.TimesheetPerformanceLineChart
												}
												ref={this.TimesheetPerLinechart}
											/>
										)}
									</div>
								</div>
							</div>
						</div>
					);
				}}
			</UserConsumer>
		);
	}
}
const mapDispatchToProps = {
	UpdateNavBarItem,
	UpdateNavBarTab,
};
export default connect(null, mapDispatchToProps)(SpDashboard);
